/*
 * @Descripttion: 采用策略模式进行数据过来
 * @Author: shenah
 * @Date: 2023-08-10 11:03:49
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-11-09 16:43:31
 */
export const filterConditionObj = {
  //等于
  equalTo: function (switchData, item) {
    let catchData = [];
    for (let i = switchData.length - 1; i >= 0; i--) {
      let conditionsArr = item.threshold?.split(",");
      conditionsArr.forEach((itemC) => {
        if (item.valueName && itemC && switchData[i][item.valueName] == itemC) {
          catchData.unshift(switchData[i]);
        }
      });
    }
    return catchData;
  },
  //不等于
  notEqualTo: function (switchData, item) {
    let nowData = _.cloneDeep(switchData);
    let conditionsArr = item.threshold?.split(",");
    conditionsArr.forEach((itemC) => {
      for (let i = nowData.length - 1; i >= 0; i--) {
        if (item.valueName && itemC && nowData[i][item.valueName] == itemC) {
          nowData.splice(i, 1);
        }
      }
    });
    return nowData;
  },
  //大于
  greaterThan: function (switchData, item) {
    let nowData = _.cloneDeep(switchData);
    for (let i = nowData.length - 1; i >= 0; i--) {
      if (item.valueName && nowData[i][item.valueName] <= item.threshold) {
        nowData.splice(i, 1);
      }
    }
    return nowData;
  },
  //大于等于
  greaterThanOrEqual: function (switchData, item) {
    let nowData = _.cloneDeep(switchData);
    for (let i = nowData.length - 1; i >= 0; i--) {
      if (item.valueName && nowData[i][item.valueName] < item.threshold) {
        nowData.splice(i, 1);
      }
    }
    return nowData;
  },
  //小于
  lessThan: function (switchData, item) {
    let nowData = _.cloneDeep(switchData);
    for (let i = nowData.length - 1; i >= 0; i--) {
      if (item.valueName && nowData[i][item.valueName] >= item.threshold) {
        nowData.splice(i, 1);
      }
    }
    return nowData;
  },
  //小于等于
  lessThanOrEqual: function (switchData, item) {
    let nowData = _.cloneDeep(switchData);
    for (let i = nowData.length - 1; i >= 0; i--) {
      if (item.valueName && nowData[i][item.valueName] > item.threshold) {
        nowData.splice(i, 1);
      }
    }
    return nowData;
  },
  //保留几位小数
  decimal: function (switchData, item) {
    let nowData = _.cloneDeep(switchData);
    let field = item.valueName;
    let num = item.threshold;
    nowData.forEach((oneData) => {
      oneData[field] =  dsf.dataview.utils.handleDecimal(
        oneData[field],
        num,
        true
      );
    });
    return nowData;
  },
  //开头匹配
  start: function (switchData, item) {
    let nowData = _.cloneDeep(switchData);
    for (let i = nowData.length - 1; i >= 0; i--) {
      let regex = new RegExp("^" + item.threshold);
      if (!regex.test(nowData[i][item.valueName])) {
        nowData.splice(i, 1);
      }
    }
    return nowData;
  },
  //结尾匹配
  last: function (switchData, item) {
    let nowData = _.cloneDeep(switchData);
    for (let i = nowData.length - 1; i >= 0; i--) {
      let regex = new RegExp(item.threshold + "$");
      if (!regex.test(nowData[i][item.valueName])) {
        nowData.splice(i, 1);
      }
    }
    return nowData;
  },
  //截取
  intercept: function (switchData, item) {
    let nowData = _.cloneDeep(switchData);
    for (let i = nowData.length - 1; i >= 0; i--) {
      if (item.firstIndex) {
        //字符串截取，firstIndex必须存在；
        let firstNum = Number(item.firstIndex),
          lastNum = Number(item.lastIndex);
        nowData = nowData.slice(firstNum, lastNum);
      }
    }
    return nowData;
  },
  //不为空
  notEmpty: function (switchData, item) {
    let nowData = _.cloneDeep(switchData);
    for (let i = nowData.length - 1; i >= 0; i--) {
      if (item.valueName && this.isEmpty(nowData[i][item.valueName])) {
        //值不存在时去掉该项
        nowData.splice(i, 1);
      }
    }
    return nowData;
  },
  //去除空格
  spliceEmpty: function (switchData, item) {
    let nowData = _.cloneDeep(switchData);
    for (let i = nowData.length - 1; i >= 0; i--) {
      if (nowData[i][item.valueName]) {
        let reg = new RegExp(item.threshold ? item.threshold : " ", "g");
        nowData[i][item.valueName] = nowData[i][item.valueName].replace(
          reg,
          ""
        );
      }
    }
    return nowData;
  },
  // 单位转化
  unitConvert: function (switchData, item) {
    let nowData = _.cloneDeep(switchData);
    let field = item.valueName;
    let unitCode = item.unitCode;
    let keepUnitDecimal = item.keepUnitDecimal;
    nowData.forEach((oneData) => {
      if (keepUnitDecimal === "") {
        oneData[field] =  dsf.dataview.utils.transformUnit(
          oneData[field],
          unitCode,
          false
        );
      } else {
        let val =  dsf.dataview.utils.transformUnit(
          oneData[field],
          unitCode,
          false
        );
        oneData[field] =  dsf.dataview.utils.handleDecimal(val, keepUnitDecimal);
      }
    });
    return nowData;
  },
  //自定义
  custom: function (switchData, item) {
    let nowData = _.cloneDeep(switchData);
    for (let i = nowData.length - 1; i >= 0; i--) {
      let v = this.$expressParams(nowData[i]);
      if (!this.$eval(item.threshold, v)) {
        nowData.splice(i, 1);
      }
    }
    return nowData;
  },
  // 升序
  asc: function (switchData, item) {
    let nowData = _.cloneDeep(switchData);
    let field = item.valueName;
    let arrField = [field]
    nowData = _.orderBy(nowData, arrField, ["asc"]);
    return nowData;
  },
  // 降序
  desc: function (switchData, item) {
    let nowData = _.cloneDeep(switchData);
    let field = item.valueName;
    let arrField = [field]
    nowData = _.orderBy(nowData, arrField, ["desc"]);
    return nowData;

  },
};
